import EditPage from "../components/EditPage";
import PageInfoEdit from "../components/PageInfoEdit";
import PageInfoListEdit from "../components/PageInfoListEdit";
import FrontPageItem from "../components/FrontPageItem";
import ImageSliderSelector from "../components/ImageSliderSelector";
import { UploadFolderIdProvider } from "../util/UploadFolderIdContext";

export default function Forside() {
    const uploadFolderId = '1QpKCYAeTMYTQIb7CC1YSi-YapKo9EnK2'
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Forside">
                <ImageSliderSelector sectionKey="slider" />
                <PageInfoEdit sectionKey="calendar" />
                <PageInfoEdit setImage={true} sectionKey="pradiken" />
                <PageInfoListEdit sectionKey="member">
                    <FrontPageItem sectionKey="deltag"/>
                    <FrontPageItem sectionKey="varMed"/>
                    <FrontPageItem sectionKey="medlem"/>
                    <FrontPageItem sectionKey="gave"/>
                </PageInfoListEdit>
                <PageInfoEdit sectionKey="blogPreview" />
                <PageInfoEdit sectionKey="nyhed" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}